/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import { lazyWithPreload as lazy } from '../react/lazyWithPreload'
import {
  URL_PLAN_SELECTION,
  URL_PLAN_SELECTION_PLANS,
  URL_ACCOUNT_CREATION,
  URL_CART_ACCOUNT_CREATION_CREATE,
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_AMBASSADORS,
  URL_ACCOUNT_INVOICE,
  URL_REMOTE_ACCOUNT_CREATE,
  URL_CHECKOUT,
  URL_LOGIN_WITH_LINK,
  URL_AI_CHAT,
  URL_AI_SHARE,
  URL_AI_DREAM,
  URL_SHORT_VIDEOS,
} from '../services/url/constants'
import { get as getConfig } from '../config/index'

// single page checkout toggle
const isSinglePageCheckoutActive = !!getConfig().features.singlePageCheckout
const videoDetailInlinePlayerEnabled = !!getConfig().features.videoDetailInlinePlayer

const LoadableFooter = lazy(
  () => import('../components/Footer/index'),
)

function isFullPlayer (location) {
  if (!location) {
    return false
  }
  const { query } = location
  return !!_get(query, 'fullplayer') && !videoDetailInlinePlayerEnabled
}

function footerHidden (location) {
  if (!location || typeof location.pathname !== 'string') {
    return false
  }
  const pathnames = [
    URL_PLAN_SELECTION,
    URL_PLAN_SELECTION_PLANS,
    URL_ACCOUNT_CREATION,
    URL_CART_ACCOUNT_CREATION_CREATE,
    URL_CART_BILLING,
    URL_CART_BILLING_PAYMENT,
    URL_CART_CONFIRMATION,
    URL_AMBASSADORS,
    URL_ACCOUNT_INVOICE,
    URL_REMOTE_ACCOUNT_CREATE,
    URL_LOGIN_WITH_LINK,
    '/get-started',
    '/give',
    '/give/email-submit',
    '/give/video',
    '/cancel-offer-modal',
    '/roku-billing',
    '/gaia-now',
    '/live',
    '/ama',
    '/who-is-watching',
    ...(isSinglePageCheckoutActive ? [URL_CHECKOUT] : []),
  ]

  // AI-1014: prefix-match the AI chat route so EVERY sub-path is covered, not
  // just the exact base path. The divination entry screens live at
  // `${URL_AI_CHAT}/:divinationEntry` (e.g. /aichat/conversation/tarot), which
  // an exact-equality check missed — letting the site footer leak onto the
  // Tarot entry screen. The footer must never appear on any AI chat route.
  if (
    location.pathname.startsWith('/share/')
    || location.pathname.startsWith(URL_SHORT_VIDEOS)
    || location.pathname.startsWith(URL_AI_CHAT)
    || location.pathname.startsWith(URL_AI_DREAM)
    // AI-1061: public AI share page renders its own chrome
    || location.pathname.startsWith(`${URL_AI_SHARE}/`)
  ) {
    return true
  }

  return _includes(pathnames, location.pathname)
}

function getFooter (props) {
  const { history, location } = props
  if (isFullPlayer(location) || footerHidden(location)) {
    return null
  }
  return (
    <LoadableFooter location={location} history={history} />
  )
}

getFooter.preload = () => LoadableFooter.preload()

export default [
  {
    path: '*',
    component: getFooter,
  },
]
